// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","ScreenXXSMax":"(max-width: 543px)","padding":"1rem","tab":"Gb05685","active":"Gefcecd","bold":"Gfa8e20"};